
import { useEffect, useState } from "react";

interface LoadingDebuggerProps {
  id: string;
  isLoading: boolean;
  dataCount: number;
  error?: any;
}

const LoadingDebugger = ({ id, isLoading, dataCount, error }: LoadingDebuggerProps) => {
  const [visible, setVisible] = useState(false);
  const [logs, setLogs] = useState<string[]>([]);

  useEffect(() => {
    // Only show in development mode
    if (import.meta.env.DEV) {
      setVisible(true);
      
      // Add timestamp to the logs
      const timestamp = new Date().toLocaleTimeString();
      setLogs(prev => [
        ...prev,
        `[${timestamp}] Component ${id}: isLoading=${isLoading}, dataCount=${dataCount}, error=${error ? JSON.stringify(error) : 'none'}`
      ].slice(-5)); // Keep only the last 5 logs
    }
  }, [id, isLoading, dataCount, error]);

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 right-0 m-4 p-2 bg-gray-800 text-white text-xs rounded shadow-lg opacity-75 z-50 max-w-md">
      <div className="font-bold mb-1">Loading Debugger: {id}</div>
      <div>Status: {isLoading ? '⏳ Loading...' : dataCount > 0 ? '✅ Loaded' : '⚠️ No Data'}</div>
      {error && <div className="text-red-400">Error: {JSON.stringify(error)}</div>}
      <div className="mt-1 border-t border-gray-600 pt-1">
        <div className="font-bold">Logs:</div>
        {logs.map((log, i) => (
          <div key={i} className="overflow-hidden text-ellipsis whitespace-nowrap">{log}</div>
        ))}
      </div>
    </div>
  );
};

export default LoadingDebugger;
